import { useState, useCallback } from 'react';

const useCheckConversation = () => {
    const [conversationExists, setConversationExists] = useState(false);
    const [conversation, setConversation] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const checkConversationExistence = useCallback(async (employeeId, type, jobPostId = null) => {
        setIsLoading(true);
    
        let fetchUrl = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/check-conversation/${employeeId}`;

        if (type === 'talent') {
            fetchUrl += `/talent`;
        } 
        
        if (type === 'application') {
            fetchUrl += `/application`;
            // Add jobPostId as query parameter if provided
            if (jobPostId) {
                fetchUrl += `?jobPostId=${jobPostId}`;
            }
        }

        try {
            const response = await fetch(fetchUrl, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const data = await response.json();
                setConversationExists(true) 
                setConversation(data.data) 
            } else {
                setConversationExists(false);
                setConversation(null);
                setError('Failed to check conversation existence.');
            }
        } catch (err) {
            setConversationExists(false);
            setConversation(null);
            setError(err.message || 'Failed to check conversation existence.');
        } finally {
            setIsLoading(false);
        }
    }, []);

    return { conversationExists, isLoading, error,conversation,  checkConversationExistence };
};

export default useCheckConversation;
